<template>
	<div class="rcd-wrap" v-if="visible">
		<!-- PC 布局 -->
		<div class="rcd-pc">
			<div class="rcd-pc-info">
				<span class="rcd-fire">🔥</span>
				<div class="rcd-pc-text">
					<span class="rcd-title">{{ $t('rebate_countdown_title') }}</span>
					<span class="rcd-rate" v-if="rebate.rebate > 0">{{ rebate.rebate * 100 }}%</span>
				</div>
			</div>
			<div class="rcd-pc-divider"></div>
			<div class="rcd-pc-countdown">
				<span class="rcd-label">{{ $t('rebate_countdown_label') }}</span>
				<div class="rcd-blocks">
					<div class="rcd-unit">
						<span class="rcd-num">{{ days }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_days') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(hours) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_hours') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(minutes) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_minutes') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(seconds) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_seconds') }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 手机端布局 -->
		<div class="rcd-mobile">
			<div class="rcd-m-header">
				<span class="rcd-fire">🔥</span>
				<span class="rcd-title">{{ $t('rebate_countdown_title') }}</span>
				<span class="rcd-live-dot"></span>
				<span class="rcd-rate" v-if="rebate.rebate > 0">{{ rebate.rebate * 100 }}%</span>
			</div>
			<div class="rcd-m-body">
				<span class="rcd-label">{{ $t('rebate_countdown_label') }}</span>
				<div class="rcd-blocks">
					<div class="rcd-unit">
						<span class="rcd-num">{{ days }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_days') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(hours) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_hours') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(minutes) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_minutes') }}</span>
					</div>
					<span class="rcd-colon">:</span>
					<div class="rcd-unit">
						<span class="rcd-num">{{ pad(seconds) }}</span>
						<span class="rcd-text">{{ $t('rebate_countdown_seconds') }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RebateCountdown',
	props: {
		rebate: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			remaining: 0,
			timer: null,
		};
	},
	computed: {
		visible() {
			return this.remaining > 0;
		},
		days() {
			return Math.floor(this.remaining / 86400);
		},
		hours() {
			return Math.floor((this.remaining % 86400) / 3600);
		},
		minutes() {
			return Math.floor((this.remaining % 3600) / 60);
		},
		seconds() {
			return this.remaining % 60;
		}
	},
	watch: {
		'rebate.leftSeconds': {
			immediate: true,
			handler(val) {
				if (val > 0) this.start(val);
			}
		}
	},
	beforeDestroy() {
		this.stop();
	},
	methods: {
		start(leftSeconds) {
			this.stop();
			this.remaining = Math.floor(leftSeconds);
			this.timer = setInterval(this.tick, 1000);
		},
		stop() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
		tick() {
			if (this.remaining <= 0) {
				this.remaining = 0;
				this.stop();
				return;
			}
			this.remaining -= 1;
		},
		pad(n) {
			return String(n).padStart(2, '0');
		}
	}
};
</script>

<style scoped>
/* ================================================================
   公共变量 & 动画
================================================================ */
.rcd-wrap {
	--rcd-color: var(--theme-color, #ff6600);
}

@keyframes rcd-blink {
	0%, 100% { opacity: 1; }
	50%       { opacity: 0.3; }
}

@keyframes rcd-badge-in {
	0%   { transform: scale(0.8); opacity: 0; }
	100% { transform: scale(1);   opacity: 1; }
}

@keyframes rcd-fire {
	0%   { transform: rotate(-12deg) scale(1);    }
	25%  { transform: rotate(10deg)  scale(1.12); }
	50%  { transform: rotate(-8deg)  scale(1.06); }
	75%  { transform: rotate(8deg)   scale(1.1);  }
	100% { transform: rotate(-12deg) scale(1);    }
}

/* ================================================================
   PC 布局
================================================================ */
.rcd-pc {
	display: flex;
	align-items: stretch;
	background: #fff;
	border-radius: 0.14rem;
	margin-top: 0.22rem;
	margin-bottom: 0.18rem;
	box-shadow: 0 0.02rem 0.14rem rgba(0, 0, 0, 0.08);
	border: 0.01rem solid #ebebeb;
	overflow: hidden;
}

/* ---- 左侧信息面板 ---- */
.rcd-pc-info {
	display: flex;
	align-items: center;
	gap: 0.12rem;
	padding: 0.18rem 0.24rem 0.18rem 0.2rem;
	background: linear-gradient(135deg, #fff8f2 0%, #fff0e0 100%);
	border-right: 0.01rem solid #f0e6d8;
	flex-shrink: 0;
}

.rcd-fire {
	font-size: 0.28rem;
	line-height: 1;
	flex-shrink: 0;
	display: inline-block;
	animation: rcd-fire 1.8s ease-in-out infinite;
	transform-origin: bottom center;
}

.rcd-pc-text {
	display: flex;
	flex-direction: column;
	gap: 0.08rem;
}

.rcd-pc .rcd-title {
	font-size: 0.18rem;
	font-weight: 700;
	color: #333;
	white-space: nowrap;
	line-height: 1.2;
}

.rcd-pc .rcd-rate {
	display: inline-block;
	background: var(--rcd-color);
	color: #fff;
	font-size: 0.18rem;
	font-weight: 800;
	padding: 0.02rem 0.1rem;
	border-radius: 0.06rem;
	white-space: nowrap;
	letter-spacing: 0.01em;
	animation: rcd-badge-in 0.4s ease both;
	align-self: flex-start;
}

/* ---- 分割线 ---- */
.rcd-pc-divider {
	width: 0.01rem;
	background: #ebebeb;
	flex-shrink: 0;
}

/* ---- 右侧倒计时 ---- */
.rcd-pc-countdown {
	display: flex;
	align-items: center;
	gap: 0.16rem;
	padding: 0.18rem 0.28rem;
	flex: 1;
}

.rcd-pc .rcd-label {
	font-size: 0.15rem;
	color: #999;
	white-space: nowrap;
	flex-shrink: 0;
}

.rcd-pc .rcd-blocks {
	display: flex;
	align-items: center;
	gap: 0.08rem;
}

.rcd-pc .rcd-unit {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.05rem;
}

.rcd-pc .rcd-num {
	background: var(--rcd-color);
	color: #fff;
	font-size: 0.26rem;
	font-weight: 800;
	width: 0.48rem;
	height: 0.44rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.06rem;
	letter-spacing: 0.02em;
	line-height: 1;
	box-shadow: 0 0.02rem 0.06rem rgba(0, 0, 0, 0.12);
}

.rcd-pc .rcd-text {
	font-size: 0.14rem;
	color: #999;
	line-height: 1;
}

.rcd-pc .rcd-colon {
	font-size: 0.22rem;
	font-weight: 700;
	color: var(--rcd-color);
	margin-bottom: 0.18rem;
	opacity: 0.7;
	line-height: 1;
	flex-shrink: 0;
}

/* ================================================================
   手机端布局（PC 隐藏）
================================================================ */
.rcd-mobile {
	display: none;
	flex-direction: column;
	background: #fff;
	border-radius: 0.2rem;
	margin-top: 0.24rem;
	margin-bottom: 0.2rem;
	box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.09);
	border: 0.01rem solid #ebebeb;
	overflow: hidden;
}

/* ---- 头部行 ---- */
.rcd-m-header {
	display: flex;
	align-items: center;
	gap: 0.12rem;
	padding: 0.22rem 0.28rem 0.2rem;
	background: linear-gradient(135deg, #fff8f2 0%, #fff0e0 100%);
	border-bottom: 0.01rem solid #f0e6d8;
}

.rcd-mobile .rcd-fire {
	font-size: 0.38rem;
	line-height: 1;
	flex-shrink: 0;
	display: inline-block;
	animation: rcd-fire 1.8s ease-in-out infinite;
	transform-origin: bottom center;
}

.rcd-mobile .rcd-title {
	font-size: 0.3rem;
	font-weight: 700;
	color: #333;
	flex: 1;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* 小圆点 live 指示器 */
.rcd-live-dot {
	width: 0.14rem;
	height: 0.14rem;
	border-radius: 50%;
	background: #22c55e;
	flex-shrink: 0;
	animation: rcd-blink 1.6s ease-in-out infinite;
}

.rcd-mobile .rcd-rate {
	background: var(--rcd-color);
	color: #fff;
	font-size: 0.36rem;
	font-weight: 800;
	padding: 0.04rem 0.16rem;
	border-radius: 0.08rem;
	white-space: nowrap;
	letter-spacing: 0.01em;
	flex-shrink: 0;
	animation: rcd-badge-in 0.4s ease both;
}

/* ---- 倒计时行 ---- */
.rcd-m-body {
	display: flex;
	align-items: center;
	gap: 0.2rem;
	padding: 0.22rem 0.28rem;
}

.rcd-mobile .rcd-label {
	font-size: 0.22rem;
	color: #999;
	white-space: nowrap;
	flex-shrink: 0;
}

.rcd-mobile .rcd-blocks {
	display: flex;
	align-items: center;
	gap: 0.1rem;
	flex: 1;
	justify-content: flex-end;
}

.rcd-mobile .rcd-unit {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.08rem;
}

.rcd-mobile .rcd-num {
	background: var(--rcd-color);
	color: #fff;
	font-size: 0.44rem;
	font-weight: 800;
	width: 0.72rem;
	height: 0.68rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.1rem;
	letter-spacing: 0.02em;
	line-height: 1;
	box-shadow: 0 0.03rem 0.1rem rgba(0, 0, 0, 0.12);
}

.rcd-mobile .rcd-text {
	font-size: 0.22rem;
	color: #999;
	line-height: 1;
}

.rcd-mobile .rcd-colon {
	font-size: 0.36rem;
	font-weight: 700;
	color: var(--rcd-color);
	margin-bottom: 0.26rem;
	opacity: 0.7;
	line-height: 1;
	flex-shrink: 0;
}

/* ================================================================
   响应式切换
================================================================ */
@media (max-width: 767px) {
	.rcd-pc     { display: none; }
	.rcd-mobile { display: flex; }
}
</style>
